import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import { clearUserData } from '.';

export const handleSignOut = async (navigate) => {
    try {
        await signOut(auth);
        clearUserData()
        navigate('/login');
        toast.success('Signed out successfully');
    } catch (error) {
        console.error('Error signing out:', error);
        toast.error('Error signing out. Please try again.');
    }
};
